<div class="error-message">{{ errorMessage }}</div>

@if (population) {
<div>
  <div class="header">
    <div>
      <h2>
        {{ 'clients.taxreturn-alias' | transloco: {taxReturnAlias}
        }}{{
          "clients.in-population-name"
            | transloco: { populationname: population?.name }
        }}
      </h2>
    </div>
    <div class="header-button-wrapper">
      <div>
        @if (isUploading && canUpload() && checkCountryAccess()) {
        <div class="ui basic blue loading button">
          {{ "clients.upload-list" | transloco }}
        </div>
        } @if (!isUploading && canUpload() && checkCountryAccess()) {
        <input
          type="file"
          id="list-upload-btn"
          (click)="$event.target.value = null"
          (change)="preStartBulkUpload($event.target.files)"
        />
        }
      </div>
      <div>
        @if (canAddTaxpayer() && checkCountryAccess()) {
        <div>
          <div
            class="ui primary button"
            [attr.data-test-ref]="'create-new-taxpayer'"
            (click)="showAddTaxpayerModal()"
          >
            {{ 'clients.manual-add-taxpayer-alias' | transloco: {taxpayerAlias} }}
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  <div id="filters">
    <div class="filter-item">
      <div class="ui left icon input">
        <i class="search icon"></i>
        <input
          id="taxpayers-input-search"
          type="text"
          [(ngModel)]="searchText"
          (ngModelChange)="updateFilteredAssignees()"
          placeholder="Search {{ taxpayerAlias }}"
        />
      </div>
    </div>
    @if (showTaxReturnType) {
    <div class="filter-item">
      <label
        >{{ 'clients.taxreturn-alias' | transloco: {taxReturnAlias} }}
        {{ "clients.type" | transloco }}</label
      >
      <div class="ui search selection dropdown" #taxReturnTypeDropdown>
        <div class="text"></div>
        <div class="menu"></div>
        <i class="chevron down icon"></i>
      </div>
    </div>
    } @if (showTaxReturnType) {
    <div class="filter-item">
      <label
        >{{ 'clients.taxreturn-alias' | transloco: {taxReturnAlias} }}
        {{ "clients.subtype" | transloco }}</label
      >
      <div class="ui search selection dropdown" #taxReturnSubTypeDropdown>
        <div class="text"></div>
        <div class="menu"></div>
        <i class="chevron down icon"></i>
      </div>
    </div>
    }
  </div>
  @if (filteredAssignees.length > 0) {
  <app-taxpayer-list
    id="taxpayer-search-list"
    [assignees]="filteredAssignees"
    [showTaxReturnType]="showTaxReturnType"
    [showQnrType]="showQnrType"
    (refreshRequired)="refresh()"
  ></app-taxpayer-list>
  } @if (filteredAssignees.length === 0) {
  <div id="no-results">
    {{ 'clients.no-tax-return-alias-s-found' | transloco: {taxReturnAlias} }}
  </div>
  }
  <div #addTaxpayerModal class="ui modal add-taxpayer">
    <div class="modal-close close icon"></div>
    <h1>
      {{ "clients.create" | transloco }}
      {{ 'clients.taxpayer-alias' | transloco: {taxpayerAlias} }}
    </h1>
    <div class="content">
      <p class="sub-heading">
        {{
          "clients.for-population-population-name"
            | transloco: { populationname: population?.name }
        }}
      </p>
      <form [formGroup]="addTaxpayerForm" (ngSubmit)="submitAddTaxpayerForm()">
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading"
              >{{ 'clients.entity-primary-name' | transloco: {entityPrimaryName}
              }}*</label
            >
            <input
              id="taxpayer-fname-input"
              type="text"
              placeholder="{{ entityPrimaryNamePlaceholder }}"
              [formControl]="firstName"
            />
          </div>
          <div class="input-col">
            <label class="label-heading"
              >{{ 'clients.entity-secondary-name' | transloco: {entitySecondaryName} }}
              <span [class.transparent]="!entitySecondaryNamePlaceholder"
                >*</span
              >
            </label>
            <input
              id="taxpayer-lname-input"
              type="text"
              placeholder="{{ entitySecondaryNamePlaceholder }}"
              [formControl]="lastName"
            />
          </div>
        </div>
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading"
              >{{ 'clients.atlas-id-variable' | transloco: {atlasIdVariable}
              }}*</label
            >
            <input
              id="taxpayer-atlasId-input"
              type="number"
              placeholder="123456"
              [formControl]="atlasId"
            />
          </div>
          @if (gtsIdVariable) {
          <div>
            <div class="input-col">
              <label
                class="label-heading"
                >{{ 'clients.gts-id-variable' | transloco: {gtsIdVariable} }}</label
              >
              <input
                id="taxpayer-gtsId-input"
                type="number"
                placeholder="123456"
                [formControl]="gtsId"
              />
            </div>
          </div>
          }
        </div>
        @if (gtsIdVariable) {
        <div>
          <div class="input-row">
            <div class="input-col">
              <label class="label-heading"
                >{{ 'clients.tax-id-variable' | transloco: {taxIdVariable}
                }}{{
                  config.featureFlags.addSpouseRequireTaxId ? "*" : ""
                }}</label
              >
              <input
                id="taxpayer-taxId-input"
                type="text"
                placeholder="123456"
                [formControl]="taxId"
              />
            </div>
          </div>
        </div>
        } @if (showTypeSubType) {
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading"
              >{{ "clients.type" | transloco }}*</label
            >
            <mat-select
              class="selection form-control small"
              formControlName="taxReturnType"
              [attr.data-test-ref]="'type'"
            >
              @for (option of taxReturnTypeOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.name }}
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="input-col">
            <label class="label-heading"
              >{{ "clients.subtype" | transloco }}*</label
            >
            <mat-select
              class="selection form-control small"
              formControlName="taxReturnSubtype"
              [attr.data-test-ref]="'subtype'"
            >
              @for (option of taxReturnSubTypeOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.name }}
              </mat-option>
              }
            </mat-select>
          </div>
        </div>
        } @if (showQnrType) {
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading"
              >QNR {{ "clients.type" | transloco }}</label
            >
            <mat-select
              class="selection form-control small"
              formControlName="qnrType"
              [attr.data-test-ref]="'qnrtype'"
            >
              @for (option of qnrTypeOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.name }}
              </mat-option>
              }
            </mat-select>
          </div>
        </div>
        }
        <!-- for enter key via ngSubmit -->
        <input type="submit" style="display: none;" />
      </form>
    </div>
    <div class="actions">
      <span id="cancel-button-taxpayer-create" class="go-back cancel">{{
        "clients.cancel" | transloco
      }}</span>
      <button
        class="ui primary background button approve"
        [disabled]="addTaxpayerForm.invalid"
        [ngClass]="{ disabled: addingTaxpayer }"
        [attr.data-test-ref]="'createButton'"
      >
        {{ "clients.create" | transloco }}
      </button>
    </div>
  </div>
</div>
}

<div #addTaxpayerSuccessModal id="success-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>

  <div class="content">
    <div class="icon green-success"></div>
    <h3>
      {{ "clients.new" | transloco }}
      {{ 'clients.taxpayer-alias' | transloco: {taxpayerAlias} }}
      <strong>{{ newTaxpayerName }}</strong>
      {{ "clients.created-successfully" | transloco }}
    </h3>
  </div>

  <div class="actions">
    <div
      id="ok-button-taxpayer-created"
      class="ui primary background button approve"
    >
      {{ "clients.ok" | transloco }}
    </div>
  </div>
</div>

<div
  #taxpayersAuthListPreUpload
  id="taxpayers-preupload-modal"
  class="ui modal"
>
  <div class="icon modal-close close"></div>

  <h1>{{ "clients.upload-list" | transloco }}</h1>

  <div class="content">
    <p class="subheading">
      {{ "clients.file-to-upload" | transloco }}
      <strong>{{ authListForUploadFile?.name }}</strong>
    </p>
    <form
      [formGroup]="authListUploadForm"
      (ngSubmit)="bulkUpload()"
      class="ui form"
    >
      <div class="field">
        @if (taxReturnTypeOptions) {
        <app-search-dropdown
          class="taxReturnType"
          label="{{ taxReturnAlias }} {{ typeAlias }}"
          [formGroup]="authListUploadForm"
          [formCtrl]="taxReturnTypeCtrl"
          [listOptions]="taxReturnTypeOptions"
        >
        </app-search-dropdown>
        }
      </div>
      <div class="field subtypes">
        @if (taxReturnSubTypeOptions) {
        <app-search-dropdown
          class="taxReturnSubType"
          label="{{ taxReturnAlias }} {{ subtypeAlias }}"
          [formGroup]="authListUploadForm"
          [formCtrl]="taxReturnSubTypeCtrl"
          [listOptions]="taxReturnSubTypeOptions"
        >
        </app-search-dropdown>
        }
      </div>
    </form>
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "clients.cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [attr.data-test-ref]="'uploadList'"
      [ngClass]="{ disabled: !authListUploadForm.valid }"
    >
      {{ "clients.upload-list" | transloco }}
    </div>
  </div>
</div>

<div
  #taxpayersUpload
  id="taxpayers-upload-modal"
  class="ui modal"
  [ngClass]="{
    tiny: !hasResults && bulkAddAssignee?.existingEntities?.length === 0
  }"
  *transloco="let t"
>
  <div class="icon modal-close close"></div>
  <div
    class="icon"
    [ngClass]="{
      'green-success': !bulkAddAssignee?.error,
      'red-error':
        bulkAddAssignee?.error || bulkAddAssignee?.existingEntities?.length > 0
    }"
  ></div>

  @if (hasResults) {
  <h2>
    {{ "clients.upload" | transloco }}
    {{ partialSuccessUpload ? t("clients.partially") : undefined }}
    {{ "clients.successful" | transloco }}
  </h2>
  } @if (!hasResults && bulkAddAssignee?.error) {
  <h2>{{ "clients.error-with-csv-upload" | transloco }}</h2>
  } @if (!hasResults && bulkAddAssignee?.existingEntities?.length > 0) {
  <h2>{{ "clients.confirmation" | transloco }}</h2>
  }

  <div class="content">
    {{ 'clients.message' | transloco: {message} }}

    <div id="results-container">
      @if (bulkAddAssignee?.assigneesWithPopulationConflict?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesWithPopulationConflict,
              title: 'have not been uploaded due to conflicts',
              success: false
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesToActionManually?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesToActionManually,
              title: 'will need to be actioned manually',
              success: false
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.csvAssigneesWithMissingAttr?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.csvAssigneesWithMissingAttr,
              title: 'have not been uploaded due to missing attributes',
              success: false
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesAdded?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesAdded,
              success: true,
              title: 'have been added'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesUpdated?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesUpdated,
              success: true,
              title: 'have been updated'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesLeftAlone?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesLeftAlone,
              success: true,
              title: 'have been left alone'
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.assigneesMovedPop?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.assigneesMovedPop,
              title: 'have moved populations',
              success: true,
              movedPop: true
            }
          "
        ></ng-container>
      </div>
      } @if (bulkAddAssignee?.newTaxReturns?.length > 0) {
      <div>
        @if (gtsIdVariable) {
        <div>
          <ng-container
            *ngTemplateOutlet="
              assigneeList;
              context: {
                assignees: bulkAddAssignee?.newTaxReturns,
                success: true,
                title: 'had Tax Return created'
              }
            "
          ></ng-container>
        </div>
        } @if (!gtsIdVariable) {
        <div>
          <ng-container
            *ngTemplateOutlet="
              assigneeList;
              context: {
                assignees: bulkAddAssignee?.newTaxReturns,
                success: true,
                title: 'had Project Form created'
              }
            "
          ></ng-container>
        </div>
        }
      </div>
      } @if (bulkAddAssignee?.updatedTaxReturns?.length > 0) {
      <div>
        @if (gtsIdVariable) {
        <div>
          <ng-container
            *ngTemplateOutlet="
              assigneeList;
              context: {
                assignees: bulkAddAssignee?.updatedTaxReturns,
                success: true,
                title: 'had Tax Return updated'
              }
            "
          ></ng-container>
        </div>
        } @if (!gtsIdVariable) {
        <div>
          <ng-container
            *ngTemplateOutlet="
              assigneeList;
              context: {
                assignees: bulkAddAssignee?.updatedTaxReturns,
                success: true,
                title: 'had Project Form updated'
              }
            "
          ></ng-container>
        </div>
        }
      </div>
      } @if (bulkAddAssignee?.existingEntities?.length > 0) {
      <div>
        <ng-container
          *ngTemplateOutlet="
            assigneeList;
            context: {
              assignees: bulkAddAssignee?.existingEntities,
              success: true,
              title: 'already exist'
            }
          "
        ></ng-container>
      </div>
      }
    </div>
  </div>

  <div class="actions">
    @if (bulkAddAssignee?.existingEntities?.length === 0) {
    <div>
      <div class="ui primary background button approve">
        {{ "clients.ok" | transloco }}
      </div>
    </div>
    } @if (bulkAddAssignee?.existingEntities?.length > 0) {
    <div>
      <span class="go-back cancel">{{
        "clients.cancel-process" | transloco
      }}</span>
      <button
        class="ui primary background button"
        [ngClass]="{ disabled: processing }"
        (click)="bulkUpload(!autoGenerateEntityId)"
      >
        {{ "clients.reuse-existing-EntityId" | transloco }}
      </button>
      <button
        class="ui primary background button"
        [ngClass]="{ disabled: processing }"
        (click)="bulkUpload(autoGenerateEntityId)"
      >
        {{ "clients.generate-new-EntityId" | transloco }}
      </button>
    </div>
    }
  </div>
</div>

<ng-template
  #assigneeList
  let-assignees="assignees"
  let-title="title"
  let-success="success"
  let-movedPop="movedPop"
>
  <div class="ui accordion">
    <div class="title" [ngClass]="{ success: success, fail: !success }">
      <h4>
        <span class="ui label" *transloco="let t"
          >{{ assignees?.length }}
          {{
            assignees.length > 1
              ? t("clients.assignees")
              : t("clients.assignee")
          }}</span
        >
        {{ title }}
      </h4>
      <i class="chevron down icon"></i>
    </div>

    <div class="content">
      <table class="ui basic compact table">
        <thead>
          <tr>
            <th>
              {{ 'clients.entity-primary-name' | transloco: {entityPrimaryName} }}
            </th>
            <th>
              {{ 'clients.entity-secondary-name' | transloco: {entitySecondaryName} }}
            </th>
            <th>
              {{ 'clients.atlas-id-variable' | transloco: {atlasIdVariable} }}
            </th>
            @if (movedPop) {
            <th>{{ "clients.new-population-name" | transloco }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (assignee of assignees; track assignee) {
          <tr>
            <td style="width:1px;padding-right: 5rem">
              {{ assignee?.firstName }}
            </td>
            <td>{{ assignee?.lastName }}</td>
            <td>{{ assignee?.atlasId }}</td>
            @if (movedPop) {
            <td>{{ (assignee?.populations)[0]?.name }}</td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
